<template>
  <div class="m-content">
    <div class="head-content">
      <div class="center-area">
    	  <p class="head-title">{{info.nickname}}</p>
    	  <p>{{info.studentCollege}}</p>
    	  <p>{{info.studentMajor}}</p>
      </div>
    </div>
    <div class="report-content">
      <div class="report-area">
        <p class="report-title">你的素质库评分为</p>
        <p class="report-score" v-html="score"></p>
      </div>
      <div class="report-area">
        <p class="report-title">各素质项得分为</p>
        <img class="report-img score-img":src=image />
      </div>
    </div>
    <div class="button-box">
      <button class="default-btn" @click="emitPlayAgain">重来一遍</button>
      <button class="default-btn" @click="emitBack">返回</button>
      <button class="default-btn" @click="emitBackActivities">返回活动广场</button>
    </div>
  </div>
</template>
<script>
import { mapState } from 'vuex'
export default {
  props: {
    score:Number,
    image:String
  },
  name: 'QualityReport',
  components: {
  },
  data() {
    return {
      info:''
    };
  },
	computed:{
	  ...mapState({
	    shengyaUser: state => state.shengyaUser.userInfo,
	  })
	},
  created(){
     this.getUserInfo()
  },
  methods:{
    //重玩一遍
    emitPlayAgain() {
      this.$emit("listenToChildEvent",'play-again')
    },
    //返回广场
    emitBackActivities() {
      // this.$store.dispatch('quitMissionGroup',this.id)
      this.$bus.$emit('back-activities')
    },
    emitBack(){
      this.$emit("listenToChildEvent",'back')
    },
    getUserInfo(){
      this.info =this.shengyaUser
    }
  }
}
</script>
<style lang="stylus" scoped>
  .head-content
    overflow:hidden
    margin: 0 0.2rem
  .left-img
    float:left
    width:1.2rem
    height:1.2rem
    border-radius:50%
    margin-top:0.4rem
  .center-area
    float:left
    font-size:0.24rem
    margin-top:0.3rem
    p
      margin:0.1rem
      line-height:0.3rem
    .head-title
      font-size:0.36rem
</style>
